import React, { useState } from 'react';

function PreviousQuotesModal({ quotes, onNewQuote, onSelectQuote, user, userDiscount }) {
    const [searchTerm, setSearchTerm] = useState('');

    const displayQuotes = quotes.filter(quote => {
        try {
            const details = JSON.parse(quote.quote_details);
            const company = details.facilityInfo ? 
                details.facilityInfo.company : 
                (details.userInfo ? details.userInfo.company : 'Unknown Company');
            const name = details.facilityInfo ? 
                details.facilityInfo.name : 
                (details.userInfo ? details.userInfo.name : '');
            
            const searchString = `${company} ${name}`.toLowerCase();
            return searchString.includes(searchTerm.toLowerCase());
        } catch (error) {
            console.error('Error parsing quote details:', error);
            return false;
        }
    });

    // Calculate metrics
    const totalQuotes = quotes.length;
    const newestQuote = quotes.length > 0 ? 
        quotes.reduce((prev, current) => 
            new Date(current.created_at) > new Date(prev.created_at) ? current : prev
        ) : null;
    
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="modal">
            <div className="modal-content dashboard-modal">
                <img src="/Logo-5.png" alt="Omntec Logo" className="modal-logo" />
                <h2 style={{ color: 'white' }}>My Dashboard</h2>
                
                {/* Dashboard Metrics */}
                <div className="dashboard-metrics">
                    <div className="metric-card">
                        <div className="metric-label">Total Quotes</div>
                        <div className="metric-value">{totalQuotes}</div>
                    </div>
                    <div className="metric-card">
                        <div className="metric-label">Distributor Discount</div>
                        <div className="metric-value">{userDiscount}%</div>
                    </div>
                    <div className="metric-card">
                        <div className="metric-label">Latest Quote</div>
                        <div className="metric-value-small">
                            {newestQuote ? (
                                <>
                                    <div>#{newestQuote.quote_number}</div>
                                    <div style={{ fontSize: '0.8em', opacity: 0.8 }}>
                                        {formatDate(newestQuote.created_at)}
                                    </div>
                                </>
                            ) : 'No quotes yet'}
                        </div>
                    </div>
                </div>

                <button onClick={onNewQuote}>New Quote</button>

                <h3 style={{ color: 'white', marginTop: '20px' }}>Your Previous Quotes</h3>
                
                <div className="search-container">
                    <input
                        type="text"
                        placeholder="Search quotes..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                </div>

                {displayQuotes.length === 0 ? (
                    <p style={{ color: 'white' }}>No quotes found.</p>
                ) : (
                    <div className="quotes-list">
                        {displayQuotes.map((quote, index) => {
                            const details = JSON.parse(quote.quote_details);
                            const company = details.facilityInfo ? 
                                details.facilityInfo.company : 
                                (details.userInfo ? details.userInfo.company : 'Unknown Company');
                            
                            return (
                                <div
                                    key={index}
                                    onClick={() => onSelectQuote(quote)}
                                    className="quote-item"
                                >
                                    <p>{company} - #{quote.quote_number}</p>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PreviousQuotesModal;
